module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.todayEvents && _vm.todayEvents.length) ? _c('div', {
    staticClass: "event-list"
  }, [(_vm.calendar) ? _c('div', {
    staticClass: "table-header"
  }, [_vm._v(_vm._s(_vm.calendar.title) + " Varaukset | " + _vm._s(_vm.$d(_vm.clock.today, "date")))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "event-table"
  }, [_c('table', {
    ref: "eventTable"
  }, [_c('thead', [_c('tr', {
    staticClass: "hours"
  }, [_c('td', {
    staticClass: "organizer"
  }), _vm._v(" "), _vm._l((_vm.hours), function(hour) {
    return _c('td', {
      key: hour
    }, [_vm._v("\n                        " + _vm._s(("0" + hour).slice(-2) + ":00") + "\n                    ")])
  })], 2), _vm._v(" "), _c('tr', {
    staticClass: "current-time"
  }, [_c('td', {
    attrs: {
      "colspan": _vm.hours.length + 1
    }
  }, [_c('div', {
    staticClass: "time-line",
    style: (_vm.currentTimeStyle())
  }, [_c('div', {
    staticClass: "time-box"
  }, [_vm._v(_vm._s(_vm.$d(_vm.clock.nowMinute, "hourMinute")))])])])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.organizers), function(organizer) {
    return _c('tr', {
      key: organizer
    }, [_c('td', {
      staticClass: "organizer"
    }, [_c('i', {
      staticClass: "icon-man"
    }), _vm._v(" "), _c('span', {
      staticClass: "organizer-name"
    }, [_vm._v(_vm._s(_vm.getFirstName(organizer)))])]), _vm._v(" "), _vm._l((_vm.hours), function(hour) {
      return _c('td', {
        key: hour
      }, _vm._l((_vm.getOrganizerReservations(organizer, hour)), function(res, index) {
        return _c('div', {
          key: index,
          staticClass: "reservation",
          style: ({
            backgroundColor: _vm.calendar.color,
            borderColor: _vm.calendar.color,
            left: res.startPercent + '%',
            width: res.lengthPercent + '%'
          })
        })
      }))
    })], 2)
  }))])])]) : (_vm.todayEvents) ? _c('div', {
    staticClass: "event-list"
  }, [_c('h1', {
    staticClass: "table-header"
  }, [_vm._v("Ei varauksia tälle päivälle")])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-64d1ec25","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./app/ts/components/OtEventList.vue
// module id = 241
// module chunks = 0